import moment from 'moment';
import { mapGetters } from 'vuex';

export const __duplicateVar = value => JSON.parse(JSON.stringify(value));

const globalMixin = {
	computed: {
		...mapGetters({
			__user: 'user',
		}),
	},
	methods: {
		__duplicateVar,
		__toTitleCase(text) {
			const result = text ? text.toUpperCase() : '';
			return result;
		},
		__showNotif(type = 'info', title = '', message = '') {
			this.$notify({
				group: 'foo-velocity',
				type,
				title,
				text: message,
			});
		},
		__currentTimeLocale() {
			// format
			let format = 'YYYY-MM-DD HH:mm';

			// Get user language
			let lang = this.__user && this.__user ? this.__user.language : 'no';
			if (lang === 'no') {
				lang = 'nb';
				format = 'DD.MM.YYYY HH:mm';
			}

			const now = moment();
			return now.locale(lang).format(format);
		},
		__dateFormat(dateTime) {
			return moment(dateTime).format('Do MMMM YYYY');
		},
		__dateFormatISO(dateTime) {
			return moment(dateTime).format('YYYY-MM-DD');
		},
		__dateTimeFormat(dateTime) {
			return moment(dateTime).format('DD.MM.YYYY HH:mm');
		},
		__dateStartFormatLocale(dateTime) {
			// format
			let format = 'DD MMMM';

			// Get user language
			let lang = this.__user && this.__user ? this.__user.language : 'no';
			if (lang === 'no') {
				lang = 'nb';
				format = 'DD. MMMM';
			}

			// Convert
			return moment(dateTime).locale(lang).format(format);
		},
		__dateEndFormatLocale(dateTime) {
			// format
			let format = 'DD MMMM YYYY';

			// Get user language
			let lang = this.__user && this.__user ? this.__user.language : 'no';
			if (lang === 'no') {
				lang = 'nb';
				format = 'DD. MMMM YYYY';
			}

			// Convert
			return moment(dateTime).locale(lang).format(format);
		},
		__dateTimeFormatLocale(dateTime) {
			// format
			let format = 'DD MMMM YYYY, HH:mm:ss';

			// Get user language
			let lang = this.__user && this.__user ? this.__user.language : 'no';
			if (lang === 'no') {
				lang = 'nb';
				format = 'DD. MMMM YYYY, HH:mm:ss';
			}

			// Convert
			return moment(dateTime).locale(lang).format(format);
		},
		__dateTimeMinuteFormatLocale(dateTime) {
			// format
			let format = 'DD MMMM YYYY, HH:mm';

			// Get user language
			let lang = this.__user && this.__user ? this.__user.language : 'no';
			if (lang === 'no') {
				lang = 'nb';
				format = 'DD. MMMM YYYY, HH:mm';
			}

			// Convert
			return moment(dateTime).locale(lang).format(format);
		},
		__dateTimeMinuteLeaveFormatLocale(dateTime) {
			// format
			let format = 'dddd, DD MMMM YYYY, HH:mm';

			// Get user language
			let lang = this.__user && this.__user ? this.__user.language : 'no';
			if (lang === 'no') {
				lang = 'nb';
				format = 'dddd D. MMMM, HH:mm';
			}

			// Convert
			return moment(dateTime).locale(lang).format(format);
		},
		__dateTimeLastFormatLocale(dateTime) {
			// format
			let format = 'HH:mm:ss';

			// Get user language
			let lang = this.__user && this.__user ? this.__user.language : 'no';
			if (lang === 'no') {
				lang = 'nb';
				format = 'HH:mm:ss';
			}

			// Convert
			return moment(dateTime).locale(lang).format(format);
		},
		__lastLoginLocale(dateTime) {
			// format
			const format = 'YYYY-MM-DD HH:mm:ss';

			// Get user language
			let lang = this.__user && this.__user ? this.__user.language : 'no';
			if (lang === 'no') lang = 'nb';

			const lastLogin = moment(dateTime, format).locale(lang).fromNow();

			// Convert
			return lastLogin;
		},
		__loginDateTimeLocale(dateTime) {
			// format
			const format = 'DD.MM.YYYY, HH:mm';

			// Get user language
			let lang = this.__user && this.__user ? this.__user.language : 'no';
			if (lang === 'no') lang = 'nb';

			const loginDate = moment(dateTime).locale(lang).format(format);

			// Convert
			return loginDate;
		},
		__dateTimeFormatISO(dateTime) {
			return moment(dateTime).format('YYYY-MM-DD HH:mm:ss');
		},
		__parseStringToArray(text) {
			const items = text && typeof text === 'string' ? JSON.parse(text) : text;
			return items;
		},
		__validURL(str) {
			const pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
              '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
              '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
              '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
              '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
              '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
			return !!pattern.test(str);
		},
		__textContent(text) {
			const value = text ? text.replace(/(?:\r\n|\r|\n)/g, '<br>') : text;
			return value;
		},
		__participantLeaveTime(participant) {
			let leaveTime = null;
			if (!participant) return leaveTime;

			const leaveRequests = participant.approved_leave_requests || [];
			if (!leaveRequests || leaveRequests.length === 0) return leaveTime;

			for (let index = 0; index < leaveRequests.length; index++) {
				const leave = leaveRequests[index];
				const leavingStart = leave.start_time;
				const leaveEnd = leave.end_time;

				if (leavingStart && leaveEnd) {
					const dateFormat = 'YYYY-MM-DD HH:mm';
					const startDate = moment(leavingStart, dateFormat);
					const endDate = moment(leaveEnd, dateFormat);
					const isBetween = moment().isBetween(startDate, endDate);

					if (isBetween) {
						leaveTime = leave;
						break;
					}
				}
			}


			return leaveTime;
		},
		__isParticipantLeave(participant) {
			let isLeave = false;
			if (!participant) return isLeave;

			const leaveRequests = participant.approved_leave_requests || [];
			if (!leaveRequests || leaveRequests.length === 0) return isLeave;

			for (let index = 0; index < leaveRequests.length; index++) {
				const leave = leaveRequests[index];
				const leavingStart = leave.start_time;
				const leaveEnd = leave.end_time;
				if (leavingStart && leaveEnd) {
					const dateFormat = 'YYYY-MM-DD HH:mm';
					const startDate = moment(leavingStart, dateFormat);
					const endDate = moment(leaveEnd, dateFormat);
					const isBetween = moment().isBetween(startDate, endDate);
					isLeave = isBetween;
					if (isLeave) break;
				}
			}
			return isLeave;
		},
		__isActiveMessageLeave(leave) {
			let isLeave = false;
			const leavingStart = leave.start_time;
			const leaveEnd = leave.end_time;
			if (leavingStart && leaveEnd) {
				const dateFormat = 'YYYY-MM-DD HH:mm';
				const startDate = moment(leavingStart, dateFormat);
				const endDate = moment(leaveEnd, dateFormat);
				const isBetween = moment().isBetween(startDate, endDate);
				isLeave = isBetween;
			}
			return isLeave;
		},
		__isParticipantAtTheFloor(participant) {
			const isValid = participant && participant.checked_floor_at;
			return isValid;
		},
		__copyHtmlToClipboard(html) {
			// Create a temporary element to hold the HTML
			const tempElement = document.createElement('div');
			tempElement.style.position = 'absolute';
			tempElement.style.left = '-9999px';

			// Append the element to the body
			document.body.appendChild(tempElement);

			// Set the HTML content
			tempElement.innerHTML = html;

			// Use the Selection API to select the text
			const range = document.createRange();
			range.selectNodeContents(tempElement);
			const selection = window.getSelection();
			selection.removeAllRanges();
			selection.addRange(range);

			// Copy the selected content to the clipboard
			try {
				document.execCommand('copy');
			} catch (err) {
				console.log('Oops, unable to copy', err);
			}

			// Remove the temporary element
			document.body.removeChild(tempElement);
		},
		__stripTags(input) {
			const doc = new DOMParser().parseFromString(input, 'text/html');
			return doc.body.textContent || '';
		},
		__sanitizeEmailHTML(html) {
			const doc = new DOMParser().parseFromString(html, 'text/html');

			// Remove img tags
			const imgTags = doc.getElementsByTagName('img');
			for (let i = imgTags.length - 1; i >= 0; i--) {
				imgTags[i].parentNode.removeChild(imgTags[i]);
			}

			// Remove iframe tags
			const iframeTags = doc.getElementsByTagName('iframe');
			for (let i = iframeTags.length - 1; i >= 0; i--) {
				iframeTags[i].parentNode.removeChild(iframeTags[i]);
			}

			return doc.body.innerHTML;
		},
		__goToPage(url) {
			window.open(url, '_blank');
		},
		__nl2br(str) {
			const breakTag = '<br>';
			return (`${str}`).replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, `$1${breakTag}$2`);
		},
	},
	mounted() {
	},
};
export default globalMixin;
